import { GC_BLANK_DEFAULT } from "../../globalConstants";
const FIRST_CHOICE = '';
const errorMessage = 'This field is required';
export const resolveValue = (values = [], entries) => {
  if (values.includes(FIRST_CHOICE)) {
    const firstValue = entries[0] && entries[0].label;
    return [firstValue];
  }
  if (values.includes(GC_BLANK_DEFAULT)) {
    return [];
  }
  return values.filter(e => e);
};
export const getValue = ({
  value,
  default: defaultValue = [],
  entry_values
}) => {
  const entryValue = value || defaultValue;
  if (entryValue.includes(FIRST_CHOICE)) {
    const firstValue = entry_values[0].text;
    return [firstValue];
  }
  if (entryValue.includes(GC_BLANK_DEFAULT)) {
    return [];
  }
  return entryValue.filter(e => e);
};
const hasValue = previewEntry => {
  const value = getValue(previewEntry);
  return value.length;
};
const hasRequiredValue = previewEntry => {
  const {
    required
  } = previewEntry;
  if (required && !hasValue(previewEntry)) {
    return errorMessage;
  }
};
export default [{
  validation: hasRequiredValue,
  type: 'required'
}];